import "./Filters.css";

const CategoryFilter = ({
	categories,
	selectedCategories,
	onCategoryToggle,
	translate,
}) => {
	return (
		<div className="category-filter">
			<h3>{translate("analysis.selectCategories")}</h3>
			<div className="category-checkboxes">
				{categories.map(category => (
					<label key={category} className="category-checkbox">
						<input
							type="checkbox"
							className={`category-${category}`}
							checked={selectedCategories.includes(category)}
							onChange={() => onCategoryToggle(category)}
						/>
						<span>{translate(`category.${category}`)}</span>
					</label>
				))}
			</div>
		</div>
	);
};

export default CategoryFilter;
